import { useState } from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { StyledCarousel } from "./styles";
import Icon from "@/atoms/Icon";

const responsive = {
  0: { items: 1 },
};

const Carousel = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const slidePrev = () => setActiveIndex(activeIndex - 1);
  const slideNext = () => setActiveIndex(activeIndex + 1);
  const onSlideChanged = ({ item }) => setActiveIndex(item);

  return (
    <StyledCarousel className={"carousel-container"}>
      <div className={"relative"}>
        <AliceCarousel
          items={items}
          infinite
          responsive={responsive}
          disableDotsControls
          disableButtonsControls
          activeIndex={activeIndex}
          onSlideChanged={onSlideChanged}
          animationDuration={400}
          autoHeight
        />
        <div className={"carousel-nav"}>
          <button onClick={slidePrev} className={"nav-btn"}>
            <Icon name={"thin-arrow-left"} size={"1.5rem"} />
          </button>
          <button onClick={slideNext} className={"nav-btn"}>
            <Icon name={"thin-arrow-right"} size={"1.5rem"} />
          </button>
        </div>
      </div>
    </StyledCarousel>
  );
};

export default Carousel;
